
import { connect } from "react-redux";
// 订单详情
import OrderDetails from "../components/OrderDetails";


const mapState = state => ({
  orderDetails: state.orderDetails,
  orderStatus: state.orderDetails.orderStatus,
  errorInfo: state.orderDetails.errorInfo,
  id: state.orderDetails.id,
  tags: state.orderDetails.tags,
  isMail: state.orderDetails.isMail,
  orderInfo: state.orderDetails.orderInfo,
  hotelInfo: state.orderDetails.hotelInfo,
  contactInfo: state.orderDetails.contactInfo,
  travelInfo: state.orderDetails.travelInfo,
  driverInfo: state.orderDetails.driverInfo,
  passengerInfo: state.orderDetails.passengerInfo,
  data: state.orderDetails.data,
  readonly: state.orderDetails.readonly,
  additionals: state.orderDetails.additionals,
  tabStatus: state.orderDetails.tabStatus,
  status: state.orderDetails.status,
});


const mapDispatch = dispatch => {
  const oi = dispatch.orderDetails;
  return {
    // 获取订单详情
    getOrderDetails: oi.getOrderDetails,
    getQNConfig: oi.getQNConfig,
    updateTabStatus: oi.updateTabStatus,
    updateErroInfo: oi.updateErroInfo,
    updateDataValue: oi.updateDataValue,
    getTraveler: oi.getTraveler,
    submit:oi.submit,
    batchSign: dispatch.orderInfo.batchSign,
  };
};

export default connect(
  mapState,
  mapDispatch
)(OrderDetails);
